module.exports = "uniform vec3\t\tclr;\nuniform sampler2D\talbedoTex;\n// uniform mat3\t\tuvTransform;\n\nvarying float factor;\n\nvoid main()\n{\n\tvec2 uv = (vec3(gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1)).xy;\n\tvec3 albedo = texture2D(albedoTex, gl_PointCoord.xy).xyz;\n\tgl_FragColor = vec4(albedo.x, albedo.y, albedo.z, 0.1 + factor * 0.9f);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/curlNoiseRender.ps
// module id = 8
// module chunks = 0